import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, tap, map, switchMap } from 'rxjs/operators';
import { LanguageService } from '../services/language.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageResolver implements Resolve<boolean> {

  constructor(
    private translate: TranslateService,
    private languageService: LanguageService
  ) {}

  resolve(): Observable<boolean> {
    // Si ya hay un idioma configurado, retornar inmediatamente
    if (this.translate.currentLang) {
      return of(true);
    }

    // Esperar a que los idiomas estén cargados desde el servicio
    return this.languageService.getLanguagesReadyObservable().pipe(
      switchMap(() => this.languageService.getLanguageList()),
      map(languageList => {
        // Obtener el idioma del navegador o usar español por defecto
        const browserLang = this.translate.getBrowserLang();
        const availableLanguages = languageList.map(lang => lang.code);

        // Verificar si el idioma del navegador está disponible
        const defaultLang = browserLang && availableLanguages.includes(browserLang) ? browserLang : availableLanguages[0];

        // Configurar el idioma por defecto
        this.translate.setDefaultLang(defaultLang);

        // Usar el idioma seleccionado
        this.translate.use(defaultLang);

        console.log(`Idioma cargado: ${defaultLang}`);
        return true;
      }),
      catchError(error => {
        console.error('Error al cargar idiomas:', error);
        // En caso de error, usar español por defecto
        this.translate.setDefaultLang('es');
        this.translate.use('es');
        return of(true);
      })
    );
  }
}
